import { render } from "./PrintFooterDesign4.vue?vue&type=template&id=7a21a626&scoped=true"
import script from "./PrintFooterDesign4.vue?vue&type=script&lang=js"
export * from "./PrintFooterDesign4.vue?vue&type=script&lang=js"

import "./PrintFooterDesign4.vue?vue&type=style&index=0&id=7a21a626&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a21a626"]])

export default __exports__